var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "PanelRow",
    { staticClass: "apptoken-company-info" },
    [
      _c(
        "Panel",
        [
          _vm.formReady && _vm.apptoken
            ? [
                _c("VueForm", {
                  staticClass: "flex-form grid fourth holder",
                  attrs: {
                    disabled: !_vm.isValid,
                    options: _vm.formOptions,
                    schema: _vm.schema,
                    model: _vm.item,
                    tag: "div"
                  },
                  on: { validated: _vm.validated }
                }),
                _vm._v(" "),
                _c("nav", { staticClass: "center controls" }, [
                  _c("label", [_c("b", [_vm._v("Active Plan:")])]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      staticClass: "custom-select",
                      on: {
                        change: function($event) {
                          _vm.changePlan($event)
                        }
                      }
                    },
                    _vm._l(_vm.billingsplans, function(billingsplans_) {
                      return _c(
                        "option",
                        {
                          key: billingsplans_.id,
                          domProps: {
                            selected:
                              billingsplans_.id ==
                              _vm.useractiveplan.billings_plans_id,
                            value: billingsplans_.id
                          }
                        },
                        [_vm._v(_vm._s(billingsplans_.name))]
                      )
                    })
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn xl",
                      attrs: { type: "button" },
                      on: { click: _vm.suspend }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("trans")("Suspend Account")) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn xl",
                      attrs: { type: "button" },
                      on: { click: _vm.activate }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("trans")("Activate Account")) +
                          "\n        "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm.loading
                  ? _c("Loading", { staticClass: "absolute" })
                  : _vm._e()
              ]
            : _c("Loading")
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a82a0cb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a82a0cb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/sections/general/CompanyProfile.vue
// module id = null
// module chunks = 